import { render, staticRenderFns } from "./AdSpendReport.vue?vue&type=template&id=da5610ec&scoped=true&"
import script from "./AdSpendReport.vue?vue&type=script&lang=js&"
export * from "./AdSpendReport.vue?vue&type=script&lang=js&"
import style0 from "./AdSpendReport.vue?vue&type=style&index=0&id=da5610ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5610ec",
  null
  
)

export default component.exports